module.exports = __webpack_public_path__ + "img/kr-product-content2-img-1.2a9eda7.png";